const contractList = {
    path: '/',
    component: resolve => require(['@/pages/admin/contract/list.vue'], resolve)
}

export default contractList